import {Slider} from './Slider';

export class SliderNavigation {

    constructor (private container:JQuery,private slider:JQuery) {
        this.slider.on('slider.change',(ev,data)=>this.onchange(ev,data));
        this.container.on('click',(ev)=>this.onclick(ev));
    }

    private onclick(ev:JQuery.TriggeredEvent) {
        let item=$(ev.target).closest('.slider-navigation-item');
        if (!item.length) return;
        let idx=item.data('index');
        if (idx===undefined) return;
        let slider=new Slider(this.slider);
        slider.scrollToIndex(idx,true);
    }

    private onchange(ev:JQuery.TriggeredEvent,data:any) {
        let items=this.container.find('.slider-navigation-item');
        items.removeClass('active');
        items.filter('[data-index="'+data.index+'"]').addClass('active');
    }

}

export {};